import { useState } from "preact/hooks";
import { AnalyticsEvents } from "@murmurations/core";
import Wordmark from "../assets/MURMURATIONS.svg";
import { EnterSplash } from "../components/EnterSplash";
import { trackAnalyticsEvent } from "../analytics";
import "./microsite.scss";

interface MinimalLandingProps {
  /** Click handler for the "Launch in AR" CTA. Same handler the full microsite uses. */
  onLaunchAR: () => void;
}

/**
 * Minimal alternate landing surface, gated by `?mode=ar` on the URL. Renders
 * only the project wordmark and a Launch AR button — no digital twin canvas,
 * no menu, no record surface. Intended for QR-code / direct-link distribution
 * where the recipient is expected to launch straight into the AR experience.
 *
 * Like the full shell, it opens behind the "Enter the Murmuration" gate —
 * the splash is a microsite-wide preload (every path, every load).
 *
 * The story queue is still fetched at the App level (AR depends on it); only
 * the second Babylon engine that the digital twin spins up is skipped here.
 * Styling: .ml-* in microsite.scss.
 */
export function MinimalLanding({ onLaunchAR }: MinimalLandingProps) {
  const [entered, setEntered] = useState(false);

  return (
    <div className="ml-shell">
      <div className="ml-center">
        <img src={Wordmark} alt="Murmurations" className="ml-wordmark" />
        <p className="ml-tagline">Stories of Migration in LA</p>
        <button
          type="button"
          onClick={() => {
            trackAnalyticsEvent(AnalyticsEvents.SELECT_CONTENT, {
              content_type: "cta",
              item_id: "launch_ar",
              item_name: "Launch AR",
            });
            onLaunchAR();
          }}
          className="ml-launch"
          aria-label="Launch the AR experience"
        >
          <span>Launch AR</span>
          <span style={{ fontWeight: 600 }} aria-hidden="true">→</span>
        </button>
      </div>

      {!entered && <EnterSplash onEnter={() => setEntered(true)} />}
    </div>
  );
}
